import { render, staticRenderFns } from "./CreateProductionCodePopUp.vue?vue&type=template&id=01201f80&scoped=true&"
import script from "./CreateProductionCodePopUp.vue?vue&type=script&lang=js&"
export * from "./CreateProductionCodePopUp.vue?vue&type=script&lang=js&"
import style0 from "./CreateProductionCodePopUp.vue?vue&type=style&index=0&id=01201f80&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01201f80",
  null
  
)

export default component.exports